import { render, staticRenderFns } from "./tableControls.vue?vue&type=template&id=604a049e"
import script from "./tableControls.vue?vue&type=script&lang=js"
export * from "./tableControls.vue?vue&type=script&lang=js"
import style0 from "./tableControls.vue?vue&type=style&index=0&id=604a049e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports